<template>
    <!-- Slider -->
    <HomePageImageSlider :slides="slides" :interval="10000" />

    <!-- Other custom content -->
    <PreLaunch/>

    <HomePageFooter/>
</template>

<script>
// @ is an alias to /src
import HomePageImageSlider from '@/components/HomePageSliderComponent.vue';
import HomePageFooter from '@/components/HomePageFooter.vue';
import PreLaunch from '@/components/PreLaunch.vue';

import slide1 from '@/assets/city_sketch_2.png'
import slide2 from '@/assets/city_sketch_3.png'
import slide3 from '@/assets/nanofiber.jpeg'

export default {
  name: 'HomeView',
  components: {
    HomePageImageSlider,
    HomePageFooter,
    PreLaunch
  },
  data() {
    return {
      slides: [
        { image: slide2, text: "Engineering every breath of tomorrow" },
        { image: slide3, text: "with cutting-edge nanofiber technology for next-generation air purification solutions and systems." },
        { image: slide1, text: "We’re listening to the streets that breathe this every day." },
        // Add more slide objects as needed
      ]
    };
  }

}
</script>
